import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const SharedSentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} width="30" height="30" viewBox="45.72 49.7 108.56 100.62">
      <svg width="24" height="33" viewBox="0 0 24 33" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_260_221)">
          <path
            d="M13.34 7.26C15.3448 7.26 16.97 5.63479 16.97 3.63C16.97 1.62521 15.3448 0 13.34 0C11.3352 0 9.71001 1.62521 9.71001 3.63C9.71001 5.63479 11.3352 7.26 13.34 7.26Z"
            fill="#32B88E"
          />
          <path
            d="M7.8 14.11C9.14 12.18 10.94 10.89 13.35 10.89C22.84 10.89 22.84 30.99 22.84 30.99"
            stroke="#32B88E"
            strokeWidth="2.23"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.5 31.1101C11.1396 31.1101 14.09 28.1596 14.09 24.5201C14.09 20.8805 11.1396 17.9301 7.5 17.9301C3.86045 17.9301 0.910004 20.8805 0.910004 24.5201C0.910004 28.1596 3.86045 31.1101 7.5 31.1101Z"
            stroke="#32B88E"
            strokeWidth="1.82"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.52 24.52H10.17"
            stroke="#32B88E"
            strokeWidth="2.23"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M7.34 27.3499V21.6899"
            stroke="#32B88E"
            strokeWidth="2.23"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_260_221">
            <rect width="23.96" height="32.11" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};
